import { createContext, useContext, useState, type ReactNode } from 'react';

// Global X-Ray overlay styles (not a CSS module — activates via data-xray-active attribute)
import '../styles/xray.css';

interface XRayState {
  enabled: boolean;
  highlightedLayer: string | null;
}

interface XRayContextValue extends XRayState {
  toggle: () => void;
  setHighlightedLayer: (layer: string | null) => void;
}

const XRayContext = createContext<XRayContextValue>({
  enabled: false,
  highlightedLayer: null,
  toggle: () => {},
  setHighlightedLayer: () => {},
});

export function XRayProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<XRayState>({
    enabled: false,
    highlightedLayer: null,
  });

  const toggle = () =>
    setState((prev) => ({ ...prev, enabled: !prev.enabled }));

  const setHighlightedLayer = (layer: string | null) =>
    setState((prev) => ({ ...prev, highlightedLayer: layer }));

  return (
    <XRayContext.Provider value={{ ...state, toggle, setHighlightedLayer }}>
      {children}
    </XRayContext.Provider>
  );
}

export function useXRay() {
  return useContext(XRayContext);
}
